import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import { Typography, Autocomplete, TextField } from '@mui/material';
import useAddBillingTemplateModalFormStyles from '../styles';
export const UtilitiesAutocomplete = observer(_ref => {
  let selectedProviderUtilities = _ref.selectedProviderUtilities,
    selectedUtilities = _ref.selectedUtilities,
    setSelectedUtilities = _ref.setSelectedUtilities,
    isCustomProviderMode = _ref.isCustomProviderMode;
  const classes = useAddBillingTemplateModalFormStyles();
  // const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    utilityInputValue = _useState2[0],
    setUtilityInputValue = _useState2[1];
  const getUnselectedUtilitiesOptions = (event, valueExt) => {
    const value = valueExt || utilityInputValue;
    if (value && value.length > 0 && isCustomProviderMode) {
      const result = [{
        id: 'customUtilityId' + '_' + utilityInputValue,
        key: 'customUtilityKey' + '_' + utilityInputValue,
        label: utilityInputValue + ' (Create Custom Utility)',
        inputName: utilityInputValue,
        isCustom: true
      }, ...(selectedProviderUtilities === null || selectedProviderUtilities === void 0 ? void 0 : selectedProviderUtilities.filter(i => {
        return selectedUtilities.findIndex(selectedUT => selectedUT.id === i.id) === -1;
      }))];
      return result;
    } else {
      const result = selectedProviderUtilities.filter(i => {
        return selectedUtilities.findIndex(selectedUT => selectedUT.id === i.id) === -1;
      }) || [];
      return result;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.please_setup_utilities'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    variant: "plain",
    id: "utilities-list",
    value: selectedUtilities || [],
    options: getUnselectedUtilitiesOptions(),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: t('add_new_property_flow.utilities')
    })),
    inputValue: utilityInputValue,
    onInputChange: (event, newInputValue) => {
      event === null || event === void 0 || event.preventDefault();
      event === null || event === void 0 || event.stopPropagation();
      setUtilityInputValue(newInputValue);
      getUnselectedUtilitiesOptions(event, newInputValue);
    },
    onChange: (e, value, situation, option) => {
      switch (situation) {
        case 'blur':
          {
            break;
          }
        case 'createOption':
          {
            break;
          }
        case 'clear':
          {
            // disable all
            setSelectedUtilities([]);
            break;
          }
        case 'selectOption':
          {
            var _option$option, _option$option2;
            // enable utility
            if ((_option$option = option.option) !== null && _option$option !== void 0 && (_option$option = _option$option.inputName) !== null && _option$option !== void 0 && _option$option.length) {
              option.option.label = option.option.inputName;
            }
            if (!(option !== null && option !== void 0 && (_option$option2 = option.option) !== null && _option$option2 !== void 0 && (_option$option2 = _option$option2.utilityTypeId) !== null && _option$option2 !== void 0 && _option$option2.length) && !!(option !== null && option !== void 0 && option.option.id.length)) {
              option.option.utilityTypeId = option.option.id;
            }
            setSelectedUtilities([...selectedUtilities, option.option]);
            break;
          }
        case 'removeOption':
          {
            // disable utility
            setSelectedUtilities([...selectedUtilities.filter(ut => ut.id !== option.option.id)]);
            break;
          }
      }
    }
  })));
});